module.exports = __webpack_public_path__ + "static/media/switch-on.30d552b3.png";